import type { PropsWithChildren } from "react";
import { Clay } from "..";
import { useSelectPortal } from "./Select.provider";

export type SelectTriggerProps = PropsWithChildren;

export const SelectTrigger = ({ children }: SelectTriggerProps) => {
  const setPortalRf = useSelectPortal();

  return <Clay ref={setPortalRf}>{children}</Clay>;
};
